import { Container, Image } from "@mantine/core";
import { useNavigate } from "react-router";

export const Header = () => {
  const navigate = useNavigate();

  return (
    <>
      <Container fluid px={0}>
        <Image
          src="/header-mitgliedervortraege-2025-04.jpg"
          width="100%"
          onClick={() => navigate("/")}
        />
      </Container>
    </>
  );
};
